// extracted by css-extract-rspack-plugin
export default {"openTrigger":"openTrigger-krifK7","wrapper":"wrapper-vUU9r8","subtitle":"subtitle-x9DrId","title":"title-jtEa0k","text":"text-f6yp6x","hide":"hide-XKCiRo"};